import React from "react";
import { QUOTE, RATING } from "../../lib/assets";
import {
  SlickSlider,
  SlickSliderArrowNext,
  SlickSliderArrowPrev,
} from "../SlickSlider/SlickSlider";

export const TestimonialAreaOne = () => {
  const slick_settings_brands = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    fade: true,
    arrows: true,
    prevArrow: (
      <SlickSliderArrowPrev classNameWrapper="testimonial-nav testimonial-nav-prev" />
    ),
    nextArrow: (
      <SlickSliderArrowNext classNameWrapper="testimonial-nav testimonial-nav-next" />
    ),
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="testimonial-area testimonial-bg">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-5 col-md-8">
            <div className="testimonial-img">
              <img src="/images/home/team-consultation.webp" alt="Zawix Business Consultants team reviewing client documents" />

              <div className="review-wrap">
                <img src={RATING} alt="" />
                <div className="content">
                  <h2 className="title">1000+</h2>
                  <p>
                    Clients <br />
                    Served
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="testimonial-item-wrap">
              <div className="section-title mb-30">
                <span className="sub-title">Client Reviews</span>
                <h2 className="title">What our clients say about Zawix</h2>
              </div>
              <div className="testimonial-active">
                <SlickSlider settings={slick_settings_brands}>
                  <div className="testimonial-item">
                    <div className="testimonial-content">
                      <div className="content-top">
                        <div className="rating">
                          <i className="fas fa-star"></i>
                          <i className="fas fa-star"></i>
                          <i className="fas fa-star"></i>
                          <i className="fas fa-star"></i>
                          <i className="fas fa-star"></i>
                        </div>
                        <div className="testimonial-quote">
                          <img src={QUOTE} alt="" />
                        </div>
                      </div>
                      <p>
                        "Zawix handled our registration and compliance process
                        professionally and kept everything clear from start to
                        finish. Their team made a complex process much easier to
                        manage."
                      </p>
                      <div className="testimonial-info">
                        <h4 className="title">Local Business Client</h4>
                        <span>Company Registration Support</span>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-item">
                    <div className="testimonial-content">
                      <div className="content-top">
                        <div className="rating">
                          <i className="fas fa-star"></i>
                          <i className="fas fa-star"></i>
                          <i className="fas fa-star"></i>
                          <i className="fas fa-star"></i>
                          <i className="fas fa-star"></i>
                        </div>
                        <div className="testimonial-quote">
                          <img src={QUOTE} alt="" />
                        </div>
                      </div>
                      <p>
                        "We needed reliable support for tax filings and
                        regulatory documentation. Zawix stayed responsive,
                        practical, and detail-oriented throughout the entire
                        engagement."
                      </p>
                      <div className="testimonial-info">
                        <h4 className="title">Corporate Compliance Client</h4>
                        <span>Tax & Compliance Services</span>
                      </div>
                    </div>
                  </div>
                </SlickSlider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
